import React from 'react'
import ReactDOM from 'react-dom/client'
import {  HashRouter } from 'react-router-dom'
import App from './components/App'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Provider } from 'react-redux'
import store from './store'

const theme = createTheme()

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        < HashRouter>
          <App />
        </HashRouter>
      </ThemeProvider>
    </Provider>,
 // </React.StrictMode>, 
  document.getElementById('root')
)
